<!-- 代理商审核 -->
<template>
	<div class="process-page">
		<!-- 机器零件信息 -->
		<div class="create-section">
			<h3>{{ partTitleObj[repairType] }}信息</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
					</div>
				</div>
				<div class="flex-1 part-info-box-right"></div>
			</div>
			<div class="process-item">
				<p>审批批注</p>
				<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="remark"></el-input>
			</div>
			<div class="create-footer">
				<el-button type="danger" @click="handleSubmit('-4')">拒绝</el-button>
				<el-button type="info" @click="handleSubmit('-2')">资料回退</el-button>
				<el-button type="primary" @click="handleSubmit('2')">同意</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { processInfo } from "@/api/claim";
export default {
	data() {
		return {
			relatedId: "",
			repairType: "",
			auditOrgName: "",
			remark: "",
			partsDetailList: [],
			createTime: "",
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
		};
	},
	mounted() {
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimWarrantyInfo(claimId);
		}
	},
	methods: {
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			processInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						sessionStorage.setItem("claimId", r.data.id);
						sessionStorage.setItem("repairType", r.data.repairType);
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
						self.relatedId = r.data.id;
						self.repairType = r.data.repairType;
						self.auditOrgName = r.data.auditOrgName;
						self.partsDetailList = [...r.data.partsDetailList];
						self.createTime = r.data.currentAudit.createTime;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		handleSubmit(type) {
			if (this.remark == "") {
				this.$message.error(`请输入审批批注`);
				return;
			}
			const typeMsg = {
				"-4": "拒绝",
				"-2": "退回",
				2: "同意",
			};
			this.$confirm(`确定${typeMsg[type]}此次索赔申请吗?`, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					this.claimWarrantyAuditAdd(type);
				})
				.catch(() => {});
		},
		// 提交
		claimWarrantyAuditAdd(auditStatus) {
			let self = this;
			const params = {
				relatedId: self.relatedId,
				auditStatus: auditStatus,
				remark: self.remark,
			};
			self.$request.post("claimWarrantyAuditAdd", true, params, function (r) {
				if (r.code == "0") {
					self.$message({
						message: "操作成功",
						type: "success",
					});
					self.$router.push({
						name: "claimReviewList",
					});
				} else {
					self.$message.error(r.msg);
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
}
</style>
